import { useDispatch, useSelector } from "react-redux";
import { setSessionExpired, setSpinnerLoading } from "../utility/Redux/modal";
import { useState } from "react";
import { selectToken } from "../utility/Redux/security";
import { useEffect } from "react";
import { selectPrefix, selectWidth } from "../utility/Redux/profile";
import MasterHelp from "../utility/component/modals/masterHelp";
import { FormatNumber2 } from "../utility/functions/formatNumber";
import moment from "moment";
import { CallAPIPromise } from "../billing/common";

const PurchaseVchBillHelp = ({ onRowClick,multySelect, status, onClose ,partyName}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    height: "80%",
    width: "auto",
    padding: "2px",
    borderRadius: "8px",
    overflow: "hidden",
    backgroundColor: "white",
  };

  const [rows, setRows] = useState([]);
  const token = useSelector(selectToken);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState(1);
  const prefix = useSelector(selectPrefix);

  const windowWidth = useSelector(selectWidth);
  const columns = [
    {
      width: 150,
      headerAlign: "center",
      align: "left",
      field: "INVNO",
      headerName: "Code",
      renderHeader: (params) => <div>Serial No.</div>,
    },
    {
      width:
        windowWidth <= 400
          ? 70
          : windowWidth <= 940
          ? 100
          : windowWidth <= 1280
          ? 80
          : 120,
      headerAlign: "center",
      align: "left",
      field: "DATE",
      renderCell: (param) => {
        if (param.value === 0) {
          return <div> {""}</div>;
        } else {
          return moment(param.value).format("DD-MM-YYYY");
        }
      },
      renderHeader: (params) => <div>Date</div>,
    },
    {
      width:
        windowWidth <= 400
          ? 70
          : windowWidth <= 940
          ? 150
          : windowWidth <= 1280
          ? 120
          : 170,
      headerAlign: "center",
      align: "left",
      field: "NAME",
      headerName: "Item Name",
      renderHeader: (params) => <div>Party Name</div>,
    },
    {
      width:
        windowWidth <= 400
          ? 70
          : windowWidth <= 940
          ? 110
          : windowWidth <= 1280
          ? 100
          : 150,
      headerAlign: "center",
      align: "left",
      field: "MOBILE",
      renderHeader: (params) => <div>Mobile</div>,
    },
    {
      field: "PUR_BILL_NO",
      renderHeader: (params) => <div>Bill No.</div>,
      width:
        windowWidth <= 768
          ? 100
          : windowWidth <= 1024
          ? 100
          : windowWidth <= 1280
          ? 70
          : windowWidth <= 1440
          ? 100
          : 150,
      headerAlign: "center",
      align: "left",
    },
    {
      width:
        windowWidth <= 768
          ? 60
          : windowWidth <= 1024
          ? 100
          : windowWidth <= 1280
          ? 120
          : windowWidth <= 1440
          ? 150
          : 150,
      headerAlign: "center",
      align: "right",
      field: "PUR_BILL_AMOUNT",
      headerName: "Rate",
      renderCell: (param) => {
        if (param.value === 0) {
          return <div> {""}</div>;
        } else {
          return FormatNumber2(param.value);
        }
      },
      renderHeader: (params) => <div>Purchase Bill Amt.</div>,
    },
  ];

  const [searchQuery, setSearchQuery] = useState("");
  const [fullList, setFullList] = useState([]);

  useEffect(() => {
    if (status) {
      if (searchQuery) {
        const regex = /\d+/;
        const searchT = searchQuery;
        if (searchT) {
          if (regex.test(searchT.substring(0, 1))) {
            getData("", "", true, searchT);
          } else {
            getData(currentPage, searchT, true);
          }
        } else {
          getData("", "");
        }
      } else {
        getData("", "");
      }
    }
  }, [searchQuery]);

  const dispatch = useDispatch();

  const getData = async (page, name, hideLoading, bill) => {
    if (!hideLoading) {
      dispatch(setSpinnerLoading("Loading"));
    }
    const data = {
      table_prefix: prefix,
      PUR_BILL_NO: bill ? bill : "",
      NAME:partyName?partyName: name ? name : "",
      page: bill || name ? 1 : page ? page : currentPage,
    };

    CallAPIPromise("/api/PurchaseVchBillHelp/PurchaseVchBillHelp", data, token)
      .then((p) => {
        if (!p.data.error) {
          let list = [];
          const data = p.data.response
          settotalPages(p.data.totalPages);
          setCurrentPage(p.data.currentPage);
          for (let i = 0; i < data.length; i++) {
            list.push({
              ...data[i],
              id: i + 1,
            });
          }
          setFullList(list);
          setRows(list);
        }
      })
      .catch((error) => {
        if (error.response.data.name === "TokenExpiredError") {
          dispatch(setSessionExpired(true));
        }
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  };

  useEffect(() => {
    if (status) {
      getData();
    }
  }, [status]);

  return (
    <>
      <div className="bg-white">
        <MasterHelp
          status={status}
          style={style}
          onClose={() => {
            setSearchQuery("");
            onClose();
            setRows([]);
          }}
          getDisabledReason={()=>"Already paid"}
          title={"Purchase Bill(s)- Help"}
          columns={columns}
          list={rows}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          onChangePagination={(page) => {
            getData(page);
            setCurrentPage(page);
          }}
          multiSelect={multySelect}
          disableIcon={"check"}
          isRowDisabled={(r)=>{
            console.log(r)
           return r.PURCHASE_INVNO_EXISTS ==="Exists"
          }}
          currentPage={currentPage}
          totalPages={totalPages}
          onRowClick={(p) => {
            onRowClick(p);
            setRows([]);
          }}
        />
      </div>
    </>
  );
};

export default PurchaseVchBillHelp;
